import { Typography } from "../../../../../core/components/molecules/Typography";

interface ISimpleCompetenceCardProps {
  score: string;
  competencia: string;
}

const SimpleCompetenceCard: React.FC<ISimpleCompetenceCardProps> = ({ score, competencia }) => {
  return (
    <div className='bg-mono-color-white flex flex-col w-full items-center justify-center gap-md rounded-md p-4 shadow-level-1'>
      <Typography
        type='title'
        size='h3'
        weight='bold'
        className='text-center'
      >
        {score}
      </Typography>
      <Typography className='text-center'>{competencia}</Typography>
    </div>
  );
};

export default SimpleCompetenceCard